import qs from 'qs';
import { api } from 'src/api/api';
import { StrapiResponse } from 'src/types/http';
import { CraWalletPDD } from 'src/types/operation';

export const getCraWalletPDD = async (operationId: string) => {
  const query = qs.stringify(
    {
      sort: ['dataReferencia:desc'],
      filters: {
        operation: {
          operationId,
        },
      },
      populate: ['operation'],
    },
    {
      encodeValuesOnly: true,
    },
  );
  const {
    data: { data },
  } = await api.get<StrapiResponse<CraWalletPDD[]>>(
    `/meta-cra-carteira-de-recebiveis-e-pdds?${query}`,
  );
  return data;
};
